// validationUtils.ts
import { withFormik } from 'formik';
import * as Yup from 'yup';

// Define Yup validation schema
const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    color: Yup.string().required('Color is required'),
    description: Yup.string().required(`Description is required`),
    isIPR: Yup.boolean(),
    isMEP: Yup.boolean(),
    isStructural: Yup.boolean(),
    isFireSprinkler: Yup.boolean()
}).test(
    'at-least-one-stage-type',
    'At least one stage type must be selected',
    function (value) {
        if (!(value?.isIPR || value?.isMEP || value?.isStructural || value?.isFireSprinkler)) {
            return this.createError({ path: 'stageType', message: 'At least one stage type must be selected' });
        }
        return true;
    }
);

// Define the enhancer with Formik and Yup
export const withFormikValidation = withFormik({
    mapPropsToValues: () => ({ name: '', color: '#000000', description: '', isIPR: false, isMEP: false, isStructural: false, isFireSprinkler: false }),
    validationSchema,
    validateOnMount: true,
    handleSubmit: () => { },
});
